import React, { useState, Fragment } from "react";
import {
  Accordion,
  AccordionHeader,
  AccordionBody,
} from "@material-tailwind/react";
import RichText from "../content/RichText";

// const data = [
//   {
//     title:
//       "ถ้าใช้บริการโรงพยาบาลเอกชนใกล้ๆ ที่ไหนมีส่วนลดให้กับบุคลากร และ นักศึกษาบ้างคะ",
//     content: "Lorem ipsum dolor sit amet, consectetur ",
//   },
//   {
//     title: "การมาใช้บริการพบแพทย์ที่ห้องพยาบาล ต้องทำอย่างไรบ้างครับ",
//     content:
//       "Nunc maximus, magna at ultricies elementum, risus turpis vulputate quam.",
//   },
//   {
//     title:
//       "สวัสดีค่ะหนูเป็น นศ.ที่มจธ.อยากสอบถามว่า หมอด้านจิตแพทย์จะเข้ามา ที่ห้องพยาบาลวันไหนบ้างคะ ",
//     content:
//       "Curabitur laoreet, mauris vel blandit fringilla, leo elit rhoncus nunc",
//   },
// ];

export default function FAQ(props) {
  const [open, setOpen] = useState(0);

  const handleOpen = (value) => {
    setOpen(open === value ? 0 : value);
  };

  const customAnimation = {
    mount: { scale: 1 },
    unmount: { scale: 0.9 },
  };

  return (
    // ความสูงกล่องให้หน้าหลักกำหนด (เท่าฝั่ง Health UPDATE) คำถามเกินกล่องเลื่อนดูในกล่อง
    <div className="h-full overflow-y-auto border-[1px] rounded-[12px] py-[6px] px-[20px] border-lightGray2">
      <Fragment>
        {props.data &&
          props.data.map((item, i) => (
            <Accordion key={i} open={open === i + 1} animate={customAnimation}>
              <AccordionHeader
                onClick={() => handleOpen(i + 1)}
                className="!text-body font-normal text-black text-left !leading-[1.2] py-[12px] faq-title"
              >
                {props.lang === "th"
                  ? item.question.detail_TH
                  : item.question.detail_EN}
              </AccordionHeader>
              <AccordionBody className="text-left faq-body">
                <RichText
                  className="content-html--compact"
                  html={
                    props.lang === "th"
                      ? item.answer.detail_TH
                      : item.answer.detail_EN
                  }
                />
              </AccordionBody>
            </Accordion>
          ))}
      </Fragment>
    </div>
  );
}
